import { css } from "@emotion/css";
import type { Properties } from "signlets";

const style = css`
  margin: 0;
`;

export const P = ({ children }: Properties<{ children: JSX.Element }>) => (
  <p class={style}>{children}</p>
);
